import React from 'react';
import AmazonProfitSummaryReport from './AmazonProfitSummaryReport';
import { AMAZON_PROFIT_SUMMARY } from '../../consts/reports';

const AmazonProfitByProductSummaryReport = (props) => (
  <AmazonProfitSummaryReport
    {...props}
    reportId={AMAZON_PROFIT_SUMMARY}
    reportTitle="Amazon Profit By Product"
    reportType="product"
  />
);

export default AmazonProfitByProductSummaryReport;
